import { v4 as uuidv4 } from 'uuid';

const SESSION_KEY = 'uiRenderer.sessionId';
const HEADER_SESSION_KEY = 'x-session-id';

export const generateRandomId = () => uuidv4().replace(/-/g, '');

// @ts-ignore
export const initTracingFields = () => sessionStorage.setItem(SESSION_KEY, window.SESSION_ID || generateRandomId());

export const clearTracingFields = () => sessionStorage.removeItem(SESSION_KEY);

export const createRequestTracingHeaders = () => ({
    [HEADER_SESSION_KEY]: sessionStorage.getItem(SESSION_KEY) || 'null',
});